import YTag from "./YM";

export default YTag
